import { createAsyncThunk } from "@reduxjs/toolkit";

import { getUserInfo } from "../../services";

/** GET CURRENT LOGGED IN USER INFORMATION */
export const userInfoAction = createAsyncThunk("userInfo", async (params) => {
  // const companyCode = localStorage.getItem("companycode");
  let response = await getUserInfo(params);
  // if (
  //   response?.data?.data?.pilotUserInfo?.userCategory === "Internal" &&
  //   Array.isArray(response?.data?.data?.pilotUserInfo?.userCompany) &&
  //   companyCode
  // ) {
  //   let filterArr = response.data.data.pilotUserInfo.userCompany.filter(
  //     (item) => item?.companyCode === companyCode
  //   );
  //   if (filterArr.length > 0) {
  //     response["data"]["data"]["pilotUserInfo"]["selectedCompany"] =
  //       filterArr || null;
  //   } else {
  //     response["data"]["data"]["pilotUserInfo"]["selectedCompany"] =
  //       response["data"]["data"]["pilotUserInfo"]["selectedCompany"][0];
  //   }
  // }
  return response.data;
});
